import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c6725cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "dataPreferenceSettings",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "qs-tabs nav nav-tabs",
  role: "tablist"
}
const _hoisted_5 = ["hidden"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Priorities", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["hidden"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Formatting Rules", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "tab-content" }
const _hoisted_12 = ["hidden"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Enable and reorder the data source priority below.")
const _hoisted_14 = ["hidden"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Tailor the data you're importing to meet your specific needs by creating personalized formatting rules.")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-divider" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Preferred Case:")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Preferred casing will only be applied to the Transfer to Form field.")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_SourceOrder = _resolveComponent("SourceOrder")!
  const _component_FieldRules = _resolveComponent("FieldRules")!
  const _component_PreferredCasing = _resolveComponent("PreferredCasing")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _createTextVNode("Data Preferences for " + _toDisplayString(_ctx.friendlyFieldName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation",
                hidden: _ctx.isHiddenTab(0)
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(0)]]),
                  id: "tab1-tab",
                  "data-bs-toggle": "tab",
                  href: "#tab1",
                  role: "tab",
                  "aria-controls": "tab1",
                  "aria-selected": "true"
                }, _hoisted_7, 2)
              ], 8, _hoisted_5),
              _createElementVNode("li", {
                class: "nav-item",
                role: "presentation",
                hidden: _ctx.isHiddenTab(1)
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(1)]]),
                  id: "tab2-tab",
                  "data-bs-toggle": "tab",
                  href: "#tab2",
                  role: "tab",
                  "aria-controls": "tab2",
                  "aria-selected": "false"
                }, _hoisted_10, 2)
              ], 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(0)]]),
                hidden: _ctx.isHiddenTab(0),
                id: "tab1",
                role: "tabpanel",
                "aria-labelledby": "tab1-tab"
              }, [
                (this.fieldAwaitComplete)
                  ? (_openBlock(), _createBlock(_component_SourceOrder, {
                      key: 0,
                      items: _ctx.fieldSettings.dataPriorityOrder,
                      isHiddenCheckboxVisible: true,
                      onCallback: _ctx.SourceOrderCallback
                    }, {
                      banner: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["items", "onCallback"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_12),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(1)]]),
                hidden: _ctx.isHiddenTab(1),
                id: "tab2",
                role: "tabpanel",
                "aria-labelledby": "tab2-tab"
              }, [
                (this.fieldAwaitComplete)
                  ? (_openBlock(), _createBlock(_component_FieldRules, {
                      key: 0,
                      friendlyFieldName: _ctx.friendlyFieldName,
                      rules: _ctx.fieldRules,
                      fieldId: _ctx.fieldId,
                      originalValue: this.fieldOriginalValue,
                      onCallback: _ctx.FieldRulesCallback
                    }, {
                      banner: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["friendlyFieldName", "rules", "fieldId", "originalValue", "onCallback"]))
                  : _createCommentVNode("", true),
                _hoisted_16,
                (this.fieldAwaitComplete)
                  ? (_openBlock(), _createBlock(_component_PreferredCasing, {
                      key: 1,
                      preferredCasing: _ctx.fieldSettings.preferredCasing
                    }, {
                      title: _withCtx(() => [
                        _hoisted_17
                      ]),
                      message: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["preferredCasing"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_14)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.SaveDataPreferenceSettings && _ctx.SaveDataPreferenceSettings(...args)))
            }, "Save"),
            _hoisted_19
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}